import { CheckmarkIcon } from "assets/icons";
import cn from "classnames";
import { formatThumbnailTimestamp } from "helpers/generateVideoThumbnails";
import { useTranslation } from "react-i18next";
import { Loader } from "ui";

import { VideoThumbnailSelectorProps } from "./VideoThumbnailSelector.types";

import styles from "./VideoThumbnailSelector.module.scss";

const THUMBNAIL_PREVIEW_HEIGHT = 80;

const VideoThumbnailSelector = ({
  thumbnails,
  selectedIndex,
  onSelect,
  isLoading,
  aspectRatio
}: VideoThumbnailSelectorProps) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={styles.thumbnailSelector__loading}>
        <Loader size={20} />
      </div>
    );
  }

  if (thumbnails.length === 0) {
    return null;
  }

  // Calculate width based on aspect ratio, or use default
  const previewWidth = aspectRatio
    ? Math.round(THUMBNAIL_PREVIEW_HEIGHT * aspectRatio)
    : 56;

  return (
    <div className={styles.thumbnailSelector}>
      <span className={styles.thumbnailSelector__label}>
        {t("Select thumbnail")}
      </span>
      <div className={styles.thumbnailSelector__grid}>
        {thumbnails.map((thumbnail, index) => (
          <div
            key={index}
            className={styles.thumbnailSelector__item}
            onClick={() => onSelect(index)}
          >
            <div
              className={cn(styles.thumbnailSelector__imageWrapper, {
                [styles["thumbnailSelector__imageWrapper--selected"]]:
                  index === selectedIndex
              })}
              style={{
                width: previewWidth,
                height: THUMBNAIL_PREVIEW_HEIGHT
              }}
            >
              <img
                src={thumbnail.dataUrl}
                alt={`Thumbnail ${index + 1}`}
                className={styles.thumbnailSelector__image}
              />
              {index === selectedIndex && (
                <div className={styles.thumbnailSelector__checkmark}>
                  <CheckmarkIcon />
                </div>
              )}
            </div>
            <span className={styles.thumbnailSelector__timestamp}>
              {formatThumbnailTimestamp(thumbnail.timestamp)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoThumbnailSelector;
